import React, { useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import Select from 'react-select';

const InfiniteSelect = ({
  options,
  value,
  onChange,
  onSearch,
  isLoadingOptions,
  isLoadingMoreOptions,
  hasMoreOptions,
  loadMoreOptions,
  children,
  ...props
}) => {
  const [isSearching, setIsSearching] = useState(false);

  const handleMenuScrollToBottom = () => {
    if (hasMoreOptions && !isLoadingOptions && !isLoadingMoreOptions) {
      loadMoreOptions();
    }
  };

  const debouncedOnSearch = useMemo(
    () =>
      debounce((query) => {
        onSearch(query);
        setIsSearching(false);
      }, 400),
    [onSearch],
  );

  const handleSearchChange = (query) => {
    setIsSearching(true);
    debouncedOnSearch(query);
  };

  return (
    <Select
      options={isSearching ? [] : options}
      value={value}
      onChange={onChange}
      onMenuScrollToBottom={handleMenuScrollToBottom}
      filterOption={() => true}
      isLoading={isLoadingOptions || isLoadingMoreOptions || isSearching}
      loadingMessage={() => 'Loading...'}
      onInputChange={handleSearchChange}
      closeMenuOnSelect
      {...props}
    >
      {children}
    </Select>
  );
};

export default InfiniteSelect;
